import {Button, Card} from "@fluentui/react-components";
import {useState} from "react";
import CancelRegistrationState from "../enums/CancelRegistrationState";
import SubText from "./SubText";
import {deleteParticipantById} from "../handlers/registrationhandler";
import ConfirmDialog from "./ConfirmDialog";

function ParticipantsObject({name, registrationId, participantsId, participantKey, onDeleted, amountOfParticipantsInBoat = 1, distanceId = 1}) {

    const [cancelRegistrationState, setCancelRegistrationState] = useState(CancelRegistrationState.INITIAL_STATE);

    async function cancelRegistration() {
        if (cancelRegistrationState === CancelRegistrationState.LOADING) {
            return;
        }
        setCancelRegistrationState(CancelRegistrationState.LOADING);

        await deleteParticipantById(registrationId, participantsId, participantKey, distanceId);

        if (onDeleted) onDeleted();
    }

    return (
      <>
          <Card className={`card`} style={{ padding: "8px 12px", margin: "6px 0" }}>
              <div
                  style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "12px",
                      flexWrap: "wrap",
                  }}
              >
                  <div>
                      <p style={{ margin: 0 }}>{name}</p>
                      <SubText text={`Boot-ID: ${registrationId} ${participantKey != null ? ` - Inschrijvingen in boot: ${amountOfParticipantsInBoat}` : ``}`} />
                  </div>
                  <div style={{display: "flex"}}>
                      <ConfirmDialog title={"Inschrijving verwijderen?"}
                                     description={`Weet u zeker dat u deze inschrijving voor ${name} wilt verwijderen?`}
                                     buttonText={cancelRegistrationState}
                                     onConfirm={async () => {await cancelRegistration()}}
                                     buttonColor={(cancelRegistrationState === CancelRegistrationState.INITIAL_STATE ? "red" : "")}/>
                  </div>
              </div>
          </Card>
      </>
    );
}

export default ParticipantsObject;